import { HTTP, authHeader } from './http-service';

class BusinessWatchlistSearchService {
  search(payload) {
    return HTTP.post(`/SchemeBusinessWatchlistSearch`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }

  advancedSearch(payload) {
    return HTTP.post(`/SchemeBusinessWatchlistSearch/advance`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }
}

export default new BusinessWatchlistSearchService();
